// extracted by mini-css-extract-plugin
export default {"control":"schedule_control__I+zmA","Cancel":"schedule_Cancel__Pjv2E"};